<template>
  <b-container fluid v-if="company">
    <b-row v-if="!isOwner && !$apollo.queries.company._loading">
      <b-col>
        <AccessDenied />
      </b-col>
    </b-row>
    <div v-else>
    <b-row>
      <b-col lg="2">
          <router-link to="/companies">
            <b-button block variant="primary" class="mb-3">Back to companies</b-button>
          </router-link>
      </b-col>
    </b-row>
      <b-row>
        <b-col sm="12">
          <iq-card body-class="profile-page p-0">
            <template v-slot:body>
              <div class="profile-header">
                <div class="profile-info p-4">
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <h2>
                            {{ company.name }}
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="user-detail">
                            <div class="d-flex flex-wrap">
                              <div>
                                <span class="d-block">
                                  <strong>CX:</strong>
                                  {{ company.contacts_aggregate.aggregate.max.cx}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-row>
                <b-col class="d-flex flex-row justify-content-between">
                  <h4 class="card-title d-inline">Contacts in company</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-table-simple responsive>
                    <b-thead>
                      <b-th>Name</b-th>
                      <b-th>Title</b-th>
                      <b-th>Email</b-th>
                      <b-th>Phone</b-th>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="contact in company.contacts" :key="contact.id">
                        <b-td>{{ contact.first_name + ' ' + contact.last_name }}</b-td>
                        <b-td>{{ contact.title | notAvailable }}</b-td>
                        <b-td>
                          <a :href="'mailto:' + contact.email">{{ contact.email | notAvailable}}</a>
                        </b-td>
                        <b-td>
                          <a :href="'tel:' + contact.phone">{{ contact.phone | notAvailable}}</a>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">History timeline</h4>
            </template>
            <template v-slot:body>
              <TimeLine :events="events" />
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import { core } from "../../config/pluginInit";
import SocialPost from "./Components/SocialPost";
import AddSocialPost from "./Components/AddSocialPost";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
import AccessDenied from './Components/AccessDenied.vue';

const GET_COMPANY_DETAIL = gql`
  query getCompanyDetail($id: uuid!) {
      companies_by_pk(id: $id) {
        id
        name
        owner_id
        contacts_aggregate {
          aggregate {
            max {
              cx
            }
          }
        }
        contacts {
          id
          first_name
          last_name
          title
          email
          phone
        }
      }
    }
`;
const LIST_EVENTS = gql`
  query listEvents($contactIds: [uuid!]!){
    events(
      where: {
        contact_id: {
          _in: $contactIds
        }
      },
      order_by: {
        created_at: desc_nulls_last
      }
      limit: 100
    ){
      id
      event_type
      data
      created_at
    }
  }
`;

export default {
  name: "CompaniesDetail",
  components: { AddSocialPost, SocialPost, AccessDenied },
  mounted() {
    core.index();
  },
  data() {
    return {
      user: {
        profile: require("../../assets/images/user/user-11.png")
      },
      account: getAccountSync(),
      events: []
    };
  },
  apollo: {
    company() {
      return {
        query: GET_COMPANY_DETAIL,
        fetchPolicy: "cache-and-network",
        variables: {
          id: this.$route.params.id
        },
        notifyOnNetworkStatusChange: true,
        update: data => {
          return data.companies_by_pk;
        }
      };
    },
  },
  computed: {
    contactIds() {
      return this.company?.contacts.map(c => c.id) || [];
    },
    isOwner(){
      if (this?.company?.owner_id === this?.account?.userId) {
        return true
      }
      return false
    }
  },
  watch: {
    contactIds: async function(val) {
      const res = await this.$apollo.query({
        query: LIST_EVENTS,
        variables: {
          contactIds: val
        }
      });
      this.events = res.data.events
    }
  },
  methods: {}
};
</script>
<style scoped>
.stage-container {
  text-align: center;
}
.stage-container h1 {
  line-height: 1;
}

.stage-column {
  display: flex;
  justify-content: flex-end;
}
.stage-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stage-wrapper h1 {
  line-height: 1;
}

.stage-wrapper h6 {
  color: lightgray;
  text-transform: uppercase;
  font-weight: bold;
}

.nba-wrapper {
  text-align: center;
}
</style>
